import { defaultLangCode } from "../constants";
export var LocaleHelper = /*#__PURE__*/function () {
  function LocaleHelper(locales, langCode) {
    if (langCode === void 0) {
      langCode = defaultLangCode;
    }
    this.locales = locales;
    this.defaultLangCode = langCode;
  }
  var _proto = LocaleHelper.prototype;
  _proto.get = function get(langCode) {
    if (langCode === void 0) {
      langCode = this.defaultLangCode;
    }
    return this.locales[langCode] || this.locales[this.defaultLangCode] || {};
  };
  return LocaleHelper;
}();